import { render } from "./ActionLogHistoryPage.vue?vue&type=template&id=1179983c"
import script from "./ActionLogHistoryPage.vue?vue&type=script&lang=js"
export * from "./ActionLogHistoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__